export const invoiceItemPriceLimits = {
    maxPrice: 99999999,
    minPrice: 0,
    minNegativePrice: -99999999,
    maxDecimalPlaces: 4,
};
